import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import TextField from 'react-md/lib/TextFields';
import Recaptcha from 'react-google-recaptcha';

import './OfferForm.css';

const RECAPTCHA_KEY = '6LcEG8cpAAAAAJwlA5frJMhD7_dE4-9sE2zkiYyF';

const encode = (data) => {
  return Object.keys(data)
    .map(key => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

class CompanyCardForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      subject: (this.props.intl.locale ==="fi"?'Rekisteröidy W-yritysasiakkaaksi':'W Business Client Registration'),
	  language: this.props.intl.locale,
      name: '',
      company: '',
      address: '',
      postcode: '',
      city: '',
      businessID: '',
      primaryUser: '',
      email: '',
      phone: '',
      terms: '',
      success: false,
      error: false,
    }
  }

  handleChange(field, value) {
    this.setState({
      [field]: value
    });
  }
  
  handleRecaptcha(value) {
    this.setState({ "g-recaptcha-response": value });
  };

  handleCheckbox(name, checkbox) {
    let array;

    if(name === 'giftCards') {
      array = this.state.giftCards;
    }

    if(array.indexOf(checkbox) === -1) {
      array.push(checkbox);
    }
    else {
      let index = array.indexOf(checkbox);
      array.splice(index, 1);
    }

    this.setState({
      [name]: array
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    if(this.state.name && this.state.company && this.state.address && this.state.postcode && this.state.city && this.state.businessID && this.state.primaryUser && this.state.email && this.state.phone && this.state.terms) {
      fetch("/", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({ "form-name": "companycard", ...this.state })
      })
      .then(() => this.setState({ success: true, error: false }))
      .catch(error => this.setState({ success: false, error: true }))
    }
    else {
      this.setState({ error: true })
    }
  }

  render() {
    return (
      <div className="offer">
        <header>
          <h3>{this.props.intl.messages["companyCardForm.heading"]}</h3>
        </header>
        { !this.state.success &&
          <form onSubmit={this.handleSubmit.bind(this)} data-netlify-recaptcha="true">
            <input type="hidden" name="form-name" value="companycard" />
            <input type="hidden" name="bot-field" value="" />
            <fieldset>
              <div>
                <TextField id="name" label={this.props.intl.messages["companyCardForm.name"]} onChange={(e) => this.handleChange('name', e)} required />
              </div>
              <div>
                <TextField id="company" label={this.props.intl.messages["companyCardForm.company"]} onChange={(e) => this.handleChange('company', e)} required />
              </div>
              <div>
                <TextField id="address" label={this.props.intl.messages["companyCardForm.address"]} onChange={(e) => this.handleChange('address', e)} required />
              </div>
              <div>
                <TextField id="postcode" className="halfwidth" label={this.props.intl.messages["companyCardForm.postcode"]} onChange={(e) => this.handleChange('postcode', e)} required />
                <TextField id="city" className="halfwidth" label={this.props.intl.messages["companyCardForm.city"]} onChange={(e) => this.handleChange('city', e)} required />
              </div>
              <div>
                <TextField id="businessID" label={this.props.intl.messages["companyCardForm.businessID"]} onChange={(e) => this.handleChange('businessID', e)} required />
              </div>
              <div>
                &nbsp;
              </div>
              <div>
                <TextField id="primaryUser" label={this.props.intl.messages["companyCardForm.primaryUser"]} onChange={(e) => this.handleChange('primaryUser', e)} required />
              </div>
              <div>
                <TextField id="email" type="email" label={this.props.intl.messages["companyCardForm.email"]} onChange={(e) => this.handleChange('email', e)} required />
              </div>
              <div>
                <TextField id="phone" type="tel" label={this.props.intl.messages["companyCardForm.phone"]} onChange={(e) => this.handleChange('phone', e)} required />
              </div>
            </fieldset>
            <fieldset className="checkbox">
              <label className="control checkbox">{this.props.intl.messages["companyCardForm.termsApprove"]} <a href="/Yritysasiakkuus-kayttoehdot" target="_blank">{this.props.intl.messages["companyCardForm.termsLink"]}</a>
                <input type="checkbox" name="terms" value="yes" onChange={(e) => this.handleChange('terms', e.currentTarget.value)} required />
                <div className="indicator" />
              </label>
            </fieldset>
            <br/>
            <Recaptcha
              ref="recaptcha"
              sitekey={RECAPTCHA_KEY}
              onChange={(val) => this.handleRecaptcha(val)}
            />
            <br/>            
            <button disabled={!this.state['g-recaptcha-response']} className="btn" type="submit">{this.props.intl.messages["companyCardForm.submit"]}</button>

          </form>
        }
        { !this.state.success && this.state.error &&
          <p className="fail">
            {this.props.intl.messages["companyCardForm.fail"]}
          </p>
        }
        {
          this.state.success &&
          <p className="success">
            {this.props.intl.messages["companyCardForm.success"]}
          </p>
        }
      </div>
    )
  }
}

CompanyCardForm.propTypes = {
  intl: intlShape.isRequired,
}

export default injectIntl(CompanyCardForm)



// WEBPACK FOOTER //
// ./src/components/CompanyCardForm.js